import { Flex, Text } from '@chakra-ui/react';
import { faWarning } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';

const DeleteFieldModal = ({
  isOpen,
  onClose,
  onConfirm
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} width={{ base: 'calc(100vw - 16px)', md: '448px' } as any}>
      <Flex padding={{ base: 4, md: 8 }} gap={6} flexDirection="column">
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">
            <FontAwesomeIcon icon={faWarning} /> Delete field?
          </Text>
          <Text textStyle="textBody">
            Are you sure you want to delete this field?
          </Text>
        </Flex>

        <Flex gap={2} justifyContent="flex-end">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="caution" onClick={onConfirm}>
            Delete
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
export default DeleteFieldModal;
